import { render, staticRenderFns } from "./Glossary.vue?vue&type=template&id=757a8a7f&scoped=true&"
import script from "./Glossary.vue?vue&type=script&lang=js&"
export * from "./Glossary.vue?vue&type=script&lang=js&"
import style0 from "./Glossary.vue?vue&type=style&index=0&id=757a8a7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757a8a7f",
  null
  
)

export default component.exports